var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "mb-0",
        attrs: {
          items: _vm.parameters,
          fields: _vm.fields,
          responsive: "",
          striped: "",
          bordered: "",
          small: "",
          "show-empty": "",
          "empty-text": _vm.$t("Nenhum parâmetro neste grupo"),
        },
        scopedSlots: _vm._u([
          {
            key: "cell(name)",
            fn: function (ref) {
              var item = ref.item
              return [
                item.name ? _c("div", [_vm._v(_vm._s(item.name))]) : _vm._e(),
                _c("em", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(item.key)),
                ]),
              ]
            },
          },
          {
            key: "cell(value)",
            fn: function (ref) {
              var item = ref.item
              return [
                item.value
                  ? _c(
                      "div",
                      {
                        staticClass: "text-muted",
                        staticStyle: {
                          "white-space": "pre-wrap",
                          "word-break": "break-all",
                          "max-width": "300px",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.truncateValue(item.value)) + " "
                        ),
                      ]
                    )
                  : _c("span", { staticClass: "text-muted" }, [_vm._v("-")]),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("e-grid-actions", {
                  attrs: {
                    "show-update": _vm.$can("Update", "Parameter"),
                    "show-delete": false,
                  },
                  on: {
                    update: function ($event) {
                      return _vm.$emit("edit", item)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }